import React, { useState } from 'react'
import useCouponData from '../../../../hooks/useCouponData';
import { CircularProgress, useMediaQuery } from '@mui/material';
import { LOGO_HOTAREA, STORE_IMAGES } from '../../../../constants/urls';
import * as S from "./Styled";
import LockIcon from "@mui/icons-material/Lock";
import Default from '../../../../components/Modal/Default/Default';
import Coupons from '../../../../components/Coupons/Coupons';
import useStoreCategoryData from '../../../../hooks/useStoreCategoryData';
import { useTheme } from '@emotion/react';
import CouponsPagination from '../../../../components/CouponsPagination/CouponsPagination';
import { FlexContainer } from '../../../../styles/common/FlexBox';
import { BotaoCupom, BoxInterno, CashbackChip, Coupon, CouponDescription, CouponImage, CouponLeft, CouponList, CouponTittle } from '../../../../components/Coupons/Styled';
import { formatCashback, getCashbackPercentage } from '../../../../components/Coupons/CouponCard';
import OnlineOffer from '../../../../components/Coupons/OnlineOffer';
import { format } from 'date-fns';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';

const AllCoupons = ({
  slug, 
  name, 
  page, 
  type, 
  limit, 
  category,
  isAuthenticated, 
  openCoupon, 
  getcouponRedirect,
  utmSource,
  utmCampaign,
  userId,
  incentiveId,
  showAlert,
  modalTitle,
  logo
}) => {
  
  const [open, setOpen] = React.useState(false);
  const [loadingRedirectId, setLoadingRedirectId] = useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const { coupons, loadingCoupon, errorCoupon, totalPages} = useCouponData({
    slug,
    name,
    page,
    type,
    limit,
    category
  });

  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width: 767px)');
  const { categorie, loadingCategorie, errorCategorie } = useStoreCategoryData({slug})

  if (loadingCoupon) return <div><CircularProgress size={20} color="inherit" /></div>;
  if (!coupons?.data || coupons.data.length === 0) {
    return <div>Nenhum cupom encontrado</div>;
  }


  const renderAuthenticatedButton = (coupon, onClickRedirect) => {
    if (coupon.type === "ONLINE") {
      return (
        <S.ButtonWrapper className="botao-cupom" onClick={() => openCoupon(coupon)}>
          <S.CouponButton>Ver Cupom</S.CouponButton>
        </S.ButtonWrapper>
      );
    }

    return (
      <S.ButtonWrapper id="pegadoroferta" className="botao-oferta click-redirect" onClick={onClickRedirect}>
        <S.CouponButton>
        {loadingRedirectId === coupon.id ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          "Ver Oferta"
        )}
      </S.CouponButton>
      </S.ButtonWrapper>
    );
  };

  const renderUnauthenticatedButton = (coupon) => {
    if (coupon.type === "ONLINE") {
      return (
        <S.ButtonWrapper className="botao-cupom"  onClick={() => handleClickOpen()}>
                      

          
          <S.CouponButton>
            Ver Cupom

                      <S.LockBadge
          >
            <LockIcon
              sx={{
                color: "white",
                fontSize: {
                  xs: "1rem",   // mobile
                  md: "1.2rem", // desktop
                },
              }}
            />
          </S.LockBadge>
            

            
            </S.CouponButton>
        </S.ButtonWrapper>
      );
    }

    return (
      <S.ButtonWrapper className="botao-oferta" onClick={() => handleClickOpen()}>
          
      <S.CouponButton>
        {loadingRedirectId === coupon.id ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          "Ver Oferta"
        )}
        <S.LockBadge>
           <LockIcon
              sx={{
                color: "white",
                fontSize: {
                  xs: "1rem",   // mobile
                  md: "1.2rem", // desktop
                },
              }}
            />
          </S.LockBadge>
      </S.CouponButton>
      </S.ButtonWrapper>
    );
  };




  return (
  <S.ContainerCoupons>
    {isMobile ? (
      coupons.data.map((coupon) => {

        const cashback = getCashbackPercentage(coupon.store, categorie);

        const onClickRedirect = async () => {

          try {
            setLoadingRedirectId(coupon.id);

            const trackedLink = await getcouponRedirect({
              link: coupon.linkUrl,
              source: utmSource,
              campaign: utmCampaign,
              userId: `${userId}`,
              coupon: `${coupon.id}`,
              store: coupon.store.slug,
              incentive: +incentiveId,
            });

            if (!trackedLink) {
              showAlert("Link de redirecionamento não retornado.", "error");
              return;
            }

            const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(
              navigator.userAgent
            );

            isMobileDevice
              ? window.location.assign(trackedLink)
              : window.open(trackedLink, "_blank", "noopener,noreferrer");
          } catch (error) {
            showAlert(
              `Erro ao redirecionar cupom: ${error.message}`,
              "error"
            );
          } finally {
            setLoadingRedirectId(null);
          }
        };

        return (
          <S.CouponBox key={coupon.id}>
            <div>
              <S.StoreImage
                src={`${STORE_IMAGES}${coupon.store.slug || "default"}.png`}
                alt=""
              />
            </div>

            <S.DescriptionBox>
              <S.StoreName>{coupon.store.name}</S.StoreName>
              {cashback && (
                <CashbackChip>{formatCashback(cashback)} de cashback</CashbackChip>
              )}
              <S.Description>{coupon.name}</S.Description>
              {isAuthenticated
                ? renderAuthenticatedButton(coupon, onClickRedirect)
                : renderUnauthenticatedButton(coupon)}
            </S.DescriptionBox>
          </S.CouponBox>
        );
      })
    ) : (
      
      coupons.data.map((coupon) => {

        const formattedDate = coupon.endDate ? format(new Date(coupon.endDate), 'dd/MM/yyyy') : '-';
        const cashback = getCashbackPercentage(coupon.store, categorie);

        const truncate = (text, maxLength) => (text?.length <= maxLength ? text : text.slice(0, maxLength) + '...');

        const titleLimit = isMobile ?  64 : 50;
        const descLimit = isMobile ? 134 : 100;

        const onClickRedirect = async () => {

          try {
            setLoadingRedirectId(coupon.id);

            const trackedLink = await getcouponRedirect({
              link: coupon.linkUrl,
              source: utmSource,
              campaign: utmCampaign,
              userId: `${userId}`,
              coupon: `${coupon.id}`,
              store: coupon.store.slug,
              incentive: +incentiveId,
            });

            if (!trackedLink) {
              showAlert("Link de redirecionamento não retornado.", "error");
              return;
            }

            const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(
              navigator.userAgent
            );

            isMobileDevice
              ? window.location.assign(trackedLink)
              : window.open(trackedLink, "_blank", "noopener,noreferrer");
          } catch (error) {
            showAlert(
              `Erro ao redirecionar cupom: ${error.message}`,
              "error"
            );
          } finally {
            setLoadingRedirectId(null);
          }
        };


        return (
          <CouponList>
            <Coupon key={coupon.id} id={coupon.id}>
                <CouponLeft>
                <FlexContainer direction="column" justify="center" align="center" position="relative">
                    <CouponImage
                    src={`${STORE_IMAGES}${coupon.store.slug || 'default'}.png`}
                    alt={coupon.store?.name || ''}
                    style={{ marginLeft: isMobile ? '0' : '16px' }}
                    />
                </FlexContainer>

                <CouponDescription>
                    <CouponTittle>{truncate(coupon.name, titleLimit)}</CouponTittle>
                    <p>{truncate(coupon.description, descLimit)}</p>
                    <FlexContainer
                    justify="flex-start"
                    mobileJustify="center"
                    gap={2}
                    align="center"
                    direction="row"
                    style={{ alignSelf: isMobile ? 'center' : 'flex-start', textAlign: 'left' }}
                    >
                    <AccessAlarmIcon sx={{ fontSize: '1rem' }} />
                    <div>Data de expiração: {formattedDate}</div>
                    {cashback && (
                      <CashbackChip style={{ marginLeft: '12px' }}>
                        {formatCashback(cashback)} de cashback
                      </CashbackChip>
                    )}
                    </FlexContainer>
                </CouponDescription>
                </CouponLeft>

                <BoxInterno>
                {isAuthenticated
                    ? renderAuthenticatedButton(coupon, onClickRedirect)
                    : renderUnauthenticatedButton(coupon)}
                </BoxInterno>
            </Coupon>
          </CouponList>
            
        )
      })
    )}

    <CouponsPagination totalPages={totalPages} couponProp={coupons.data} scrollId="acabou-de-chegar"/>

      
     
      <Default 
      slug={slug}
      name={modalTitle}
      open={open}
      handleClose={handleClose}
      incentiveId={incentiveId}
      logo={logo}
      
      />
    </S.ContainerCoupons>
    
  );
};

export default AllCoupons